<style lang="scss" scoped>
.page-info {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  &__item {
    flex: 1;
    border-right: 1px solid #dddddd;
    text-align: center;
    padding: 20px 0;
    &:last-child {
      border: none;
    }
    .title {
      font-size: 1.2em;
      color: #999;
      margin-bottom: 15px;
    }
    .num {
      font-size: 24px;
      color: #333;
    }
  }
}
</style>
<template>
  <div>
    <el-card>
      <div
        slot="header"
        class="clearfix"
      >
        <span>搜索</span>
      </div>
      <el-form
        :inline="true"
        size="mini"
      >
        <el-form-item label="导购：">
          <el-input
            placeholder="请输入创建红包人员名称"
            style="width: 220px"
          />
        </el-form-item>
        <el-form-item label="导购手机号：">
          <el-input placeholder="请输入导购手机号" />
        </el-form-item>
        <!-- <el-form-item label="领取状态：">
                <el-select placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item> -->
        <div>
          <el-form-item
            label="发放时间："
            prop="time"
          >
            <el-date-picker
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary">
              查询
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-card>
    <div class="page-info">
      <div class="page-info__item">
        <p class="title">
          今日发放红包数（个）
        </p>
        <p class="num">
          0
        </p>
      </div>
      <div class="page-info__item">
        <p class="title">
          总发放红包数（个）
        </p>
        <p class="num">
          0
        </p>
      </div>
      <div class="page-info__item">
        <p class="title">
          今日已发放金额（元）
        </p>
        <p class="num">
          0
        </p>
      </div>
      <div class="page-info__item">
        <p class="title">
          已发放总金额（元）
        </p>
        <p class="num">
          0
        </p>
      </div>
      <div class="page-info__item">
        <p class="title">
          剩余额度 （元）
        </p>
        <p class="num">
          0
        </p>
      </div>
    </div>
    <div>
      <SpFinder
        ref="finder"
        :url="{
          data: requestUrl
        }"
        title="数据"
        :columns="columns"
        :actions="actions"
        :hooks="{
          beforeSearch: beforeSearch
        }"
      />
    </div>
  </div>
</template>
<script>
export default {
  data () {
    const columns = [
      {
        name: '红包发放时间',
        key: 'time'
      },
      {
        name: '导购',
        key: 'guide'
      },
      {
        name: '客户昵称',
        key: 'nickname'
      },
      {
        name: '状态',
        key: 'status'
      },
      {
        name: '红包金额（元）',
        key: 'price'
      }
    ]
    const actions = [
      // {
      //     name: '详情',
      //     key: 'detail',
      //     type: 'button',
      //     action: {
      //       type: 'link',
      //       path: (row, selections) => `/membership/membershipSopEdit?id=${row.id}` // 字符串方式跳转
      //     }
      //   },
    ]
    return {
      requestUrl: `${process.env.VUE_APP_BASE_API + '/setting/red-envelope-setting-logs'}`,
      columns,
      actions
    }
  },
  mounted () {},
  methods: {}
}
</script>
